/** Open/close state for the Ask CIGS panel, plus a ready-made trigger button for it. */
import { useCallback, useState } from 'react';
import { MessageCircleQuestion } from 'lucide-react';
import { Button, type ButtonProps } from '@/components/ui/button';

export interface AskLauncher {
  open: boolean;
  launch: () => void;
  close: () => void;
  onOpenChange: (open: boolean) => void;
}

/** Owns the panel's open state so a page only has to wire up `<AskPanel {...launcher} />`. */
export function useAskLauncher(): AskLauncher {
  const [open, setOpen] = useState(false);
  const launch = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  return { open, launch, close, onOpenChange: setOpen };
}

export function AskLauncherButton({
  onClick,
  children,
  ...props
}: Omit<ButtonProps, 'onClick'> & { onClick: () => void }) {
  return (
    <Button type="button" variant="outline" size="sm" onClick={onClick} className="gap-1.5" {...props}>
      <MessageCircleQuestion className="h-4 w-4" aria-hidden />
      {children ?? 'Ask CIGS'}
    </Button>
  );
}
